import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, renderList as _renderList } from "vue"
import _imports_0 from '@/assets/attendance/icon-calc.png'


const _hoisted_1 = { class: "container block" }
const _hoisted_2 = {
  key: 0,
  class: "filter"
}
const _hoisted_3 = { class: "button-group" }
const _hoisted_4 = {
  key: 1,
  class: "filter"
}
const _hoisted_5 = { class: "button-group" }
const _hoisted_6 = { class: "overview" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "form" }
const _hoisted_10 = { class: "field" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "field" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "field" }
const _hoisted_16 = { class: "value" }
const _hoisted_17 = {
  key: 1,
  class: "field"
}
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "field" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "field" }
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "field" }
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "price" }
const _hoisted_26 = { class: "number" }
const _hoisted_27 = { class: "content" }
const _hoisted_28 = { class: "flex items-center gap-4" }
const _hoisted_29 = {
  key: 0,
  class: "label"
}
const _hoisted_30 = {
  key: 1,
  class: "label"
}
const _hoisted_31 = { class: "value" }
const _hoisted_32 = { style: {"text-align":"right"} }

import { ref } from 'vue'
import router from '@/router'
import { DateRangeGroupEnum, toChineseNum, ShiftTypeEnum, PriceTypeEnum, WorkHourLimitTypeEnum, CalculateTypeDataset, RoundTypeDataset } from './components/attendance'
import CalcRule from './components/calc-rule.vue'
import dayjs from 'dayjs'
import { ElMessage } from 'element-plus'
import { calculateWorkingHours, CalculateWorkingHoursParams, exportWorkHours, getAttendanceRecordList, exportAttendanceRecord } from '@/api/attendance'
import { cloneDeep, assign } from 'lodash'
import { formatter } from '@/utils/util'
import _Row from 'element-plus/lib/components/row'


export default /*@__PURE__*/_defineComponent({
  __name: 'machine-detail',
  setup(__props) {

const calcRule = ref()
const machineId = ref<number>(0)
const machineDetail = ref({
    id: 0,
    name: '',
    serveCompanyId: ''
})
const machineLoading = ref(false)

const filterData = ref({
    dateRangeGroup: DateRangeGroupEnum.Today as typeof DateRangeGroupEnum.valueType,
    dateRange: [],
    startDate: '',
    endDate: ''
})
const calcRuleData = ref({} as CalculateWorkingHoursParams)
const paginationData = ref({
    pageSize: 15,
    total: 0,
    current: 1
})
const isHourCalculation = ref(false)
const estimateAmount = ref(0)
const tableData = ref([])
const dayCol = ref([] as { date: string, weekday: string }[])

const onSetup = () => {
    const route = router.currentRoute.value
    machineId.value = typeof route.params.id === 'string' ? Number(route.params.id) : 0
    machineDetail.value = {
        id: machineId.value,
        name: route.query.name as string,
        serveCompanyId: route.query.serveCompanyId as string
    }
    onQueryData()
}

const formatDateRange = () => {
    if (filterData.value.dateRangeGroup === DateRangeGroupEnum.Custom) {
        filterData.value.startDate = filterData.value.dateRange[0]
        filterData.value.endDate = filterData.value.dateRange[1]
    } else {
        const { startDate, endDate } = DateRangeGroupEnum.getDatePresetRange({
            type: filterData.value.dateRangeGroup
        })
        filterData.value.startDate = startDate
        filterData.value.endDate = endDate
    }
}

const onQueryData = async () => {
    console.log('onQueryData')
    formatDateRange()
    machineLoading.value = true

    const params = {
        pageSize: paginationData.value.pageSize,
        pageNum: paginationData.value.current,
        facilityId: machineId.value,
        serveCompanyId: machineDetail.value.serveCompanyId
    } as any

    let res

    assign(params, cloneDeep(isHourCalculation.value ? calcRuleData.value : filterData.value))

    if (params.workHourLimitType === WorkHourLimitTypeEnum.Integer) {
        delete params.workHourLimitReduce
    }
    delete params.workHourLimitType
    delete params.workNextDay

    delete params.dateRange
    delete params.dateRangeGroup

    res = isHourCalculation.value ? await calculateWorkingHours(params as any) : await getAttendanceRecordList(params as any)

    tableData.value = res.list || []
    estimateAmount.value = res.estimateAmount
    paginationData.value.total = res.totalCount
    dayCol.value = tableData.value?.[0]?.checkInRecordList?.map(item => {
        return {
            date: item.date,
            weekday: item.weekday
        }
    }) || [
        {
            date: params.startDate,
            weekday: ''
        }
    ]
    machineLoading.value = false
}

const onChangeDateRange = (value: [string, string] | null) => {
    if (value && value[0] && value[1]) {
        const start = dayjs(value[0])
        const end = dayjs(value[1])
        const diffDays = end.diff(start, 'day')

        if (diffDays > 62) {
            ElMessage.warning('时间范围不能超过2个月')
            return
        }
    }

    filterData.value.dateRange = value || []
    filterData.value.dateRangeGroup = Array.isArray(value) && value[1] ? DateRangeGroupEnum.Custom : DateRangeGroupEnum.Today
    onQueryData()
}

const onChangeCalculation = (value) => {
    if (value) {
        calcRule.value.open(assign(cloneDeep(calcRuleData.value), {
            facilityId: machineId.value,
            serveCompanyId: machineDetail.value.serveCompanyId,
            startDate: filterData.value.startDate,
            endDate: filterData.value.endDate
        }))
    } else {
        isHourCalculation.value = value
        calcRuleData.value = {}
        onQueryData()
    }
}

const onSubmitCalc = (ruleData) => {
    console.log('onSubmitCalc', ruleData)
    calcRuleData.value = ruleData
    isHourCalculation.value = true
    onQueryData()
}

const onExportAttendance = async () => {
    const params: any = assign({
        facilityId: machineId.value,
        serveCompanyId: machineDetail.value.serveCompanyId
    }, cloneDeep(filterData.value))
    delete params.dateRange
    delete params.dateRangeGroup
    const result = await exportAttendanceRecord(params)

    window.location.href = process.env.VUE_APP_BASE_URL + '/common/download?delete=true&fileName=' + result
    ElMessage.success('导出成功')
}

const onExportWorkHour = async () => {
    const params: any = assign({
        facilityId: machineId.value,
        serveCompanyId: machineDetail.value.serveCompanyId
    }, cloneDeep(calcRuleData.value))
    if (params.workHourLimitType === WorkHourLimitTypeEnum.Integer) {
        delete params.workHourLimitReduce
    }
    delete params.workHourLimitType
    delete params.workNextDay
    delete params.dateRange
    delete params.dateRangeGroup
    const result = await exportWorkHours(params)

    window.location.href = process.env.VUE_APP_BASE_URL + '/common/download?delete=true&fileName=' + result

    ElMessage.success('导出成功')
}

onSetup()

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_ZoomIn = _resolveComponent("ZoomIn")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isHourCalculation.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (onChangeCalculation(false)))
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("取消计算")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (onChangeCalculation(true))),
              class: "calc"
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "",
                  class: "icon"
                }, null, -1),
                _createElementVNode("span", null, "调整计算", -1)
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: onExportWorkHour
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("导出工时名单")
              ])),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_el_radio_group, {
            modelValue: filterData.value.dateRangeGroup,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterData.value.dateRangeGroup) = $event)),
            onChange: onQueryData
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_button, {
                label: _unref(DateRangeGroupEnum).Today
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("今天")
                ])),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_radio_button, {
                label: _unref(DateRangeGroupEnum).Week
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("近7天")
                ])),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_radio_button, {
                label: _unref(DateRangeGroupEnum).Month
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode("本月")
                ])),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_date_picker, {
            class: _normalizeClass(["date-picker", [filterData.value.dateRangeGroup === _unref(DateRangeGroupEnum).Custom && 'active']]),
            modelValue: filterData.value.dateRange,
            type: "daterange",
            "range-separator": "-",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            "value-format": "YYYY-MM-DD",
            "onUpdate:modelValue": onChangeDateRange
          }, null, 8, ["class", "modelValue"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (onChangeCalculation(true))),
              type: "primary"
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode("算工时")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: onExportAttendance
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [
                _createTextVNode("导出考勤名单")
              ])),
              _: 1
            })
          ])
        ])),
    (isHourCalculation.value)
      ? _withDirectives((_openBlock(), _createBlock(_component_el_card, {
          key: 2,
          class: "overview-card",
          shadow: "none"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(machineDetail.value.name), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "label" }, "班次规则", -1)),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(ShiftTypeEnum).label(calcRuleData.value.shiftType)), 1)
                  ]),
                  (calcRuleData.value.priceType === _unref(PriceTypeEnum).PerHour)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_12, [
                          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "label" }, "按小时计算", -1)),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("span", null, "工时上限" + _toDisplayString(calcRuleData.value.workHourLimit) + "小时", 1),
                            (calcRuleData.value.workHourLimitType === _unref(WorkHourLimitTypeEnum).Subtract)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, "减" + _toDisplayString(calcRuleData.value.workHourLimitReduce) + "小时", 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "label" }, "时薪", -1)),
                          _createElementVNode("div", _hoisted_16, _toDisplayString(calcRuleData.value.price) + "元/时", 1)
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  (calcRuleData.value.priceType === _unref(PriceTypeEnum).FixedAmount)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "label" }, "固定金额", -1)),
                        _createElementVNode("div", _hoisted_18, _toDisplayString(calcRuleData.value.price) + "元/天", 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_19, [
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "label" }, "计算方式", -1)),
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(formatter)(calcRuleData.value.calculateType, _unref(CalculateTypeDataset) as any, {
                                valueKey: 'value' })), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "label" }, "取整方式", -1)),
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(formatter)(calcRuleData.value.roundType, _unref(RoundTypeDataset) as any, {
                                valueKey:
                                'value' })), 1)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "label" }, "算薪日期", -1)),
                    _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(dayjs)(calcRuleData.value.startDate).format('MM.DD')) + "-" + _toDisplayString(_unref(dayjs)(calcRuleData.value.endDate).format('MM.DD')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "label" }, "预计发薪总额(元)", -1)),
                _createElementVNode("div", null, [
                  _cache[21] || (_cache[21] = _createElementVNode("span", { class: "prefix" }, "¥", -1)),
                  _createElementVNode("span", _hoisted_26, _toDisplayString(estimateAmount.value), 1)
                ])
              ])
            ])
          ]),
          _: 1
        })), [
          [_directive_loading, machineLoading.value]
        ])
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_27, [
      _createVNode(_component_el_table, { data: tableData.value }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "姓名",
            fixed: "left",
            prop: "userName",
            "min-width": "120"
          }),
          _createVNode(_component_el_table_column, { label: "基本信息" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "身份证",
                prop: "idCardNo",
                "min-width": "200"
              }),
              _createVNode(_component_el_table_column, {
                label: "是否注册",
                prop: "isRegister",
                "min-width": "100",
                formatter: (row) => row.isRegister ? '是' : '否'
              }, null, 8, ["formatter"])
            ]),
            _: 1
          }),
          (isHourCalculation.value)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                label: "考勤统计"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "应付工资(仅供参考)",
                    prop: "totalAmount",
                    align: "right",
                    "min-width": "180"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "合计工时",
                    prop: "totalWorkHours",
                    align: "right",
                    "min-width": "180"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dayCol.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: item.date,
              label: `${item.date} ${item.weekday}`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "当天工时",
                  prop: `checkInRecordList.${index}.totalHours`,
                  "min-width": "120"
                }, null, 8, ["prop"]),
                _createVNode(_component_el_table_column, {
                  label: "第一次打卡",
                  prop: `checkInRecordList.${index}.firstCheckIn`,
                  "min-width": "120"
                }, null, 8, ["prop"]),
                _createVNode(_component_el_table_column, {
                  label: "最后打卡",
                  prop: `checkInRecordList.${index}.lastCheckIn`,
                  "min-width": "120"
                }, null, 8, ["prop"]),
                _createVNode(_component_el_table_column, {
                  label: "原始记录",
                  prop: "signRecord",
                  "min-width": "120"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.checkInRecordList[index].originalRecord?.length)
                      ? (_openBlock(), _createBlock(_component_el_popover, {
                          key: 0,
                          class: "box-item",
                          placement: "bottom"
                        }, {
                          reference: _withCtx(() => [
                            _createVNode(_component_el_link, { type: "default" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_28, [
                                  _cache[23] || (_cache[23] = _createElementVNode("span", null, "查看", -1)),
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ZoomIn)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_scrollbar, { class: "sign-record" }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.checkInRecordList[index].originalRecord, (recordItem, recordIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: recordItem,
                                    class: "cell"
                                  }, [
                                    (recordIndex && (recordIndex + 1) === scope.row.checkInRecordList[index].originalRecord?.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, "最后打卡 "))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_30, "第" + _toDisplayString(_unref(toChineseNum)(recordIndex + 1)) + "次打卡", 1)),
                                    _createElementVNode("div", _hoisted_31, _toDisplayString(recordItem), 1)
                                  ]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["label"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["data"]),
      _createElementVNode("div", _hoisted_32, [
        _createVNode(_component_el_pagination, {
          "page-size": paginationData.value.pageSize,
          "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((paginationData.value.pageSize) = $event)),
          "current-page": paginationData.value.current,
          "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((paginationData.value.current) = $event)),
          total: paginationData.value.total,
          layout: "prev, pager, next",
          onCurrentChange: onQueryData
        }, null, 8, ["page-size", "current-page", "total"])
      ])
    ])), [
      [_directive_loading, machineLoading.value]
    ]),
    _createVNode(CalcRule, {
      ref_key: "calcRule",
      ref: calcRule,
      onSubmit: onSubmitCalc
    }, null, 512)
  ]))
}
}

})